import cx from 'classnames';

import Typography from '~/components/Typography';

import type { FAQSection as FAQSectionProps } from '~/interfaces/faq_section';

import MarkDownRender from '../Markdown/MarkDownRender';
import FAQs from './FAQs';

interface Props {
  faq_section: FAQSectionProps;
  isFirstQuestionOpen?: boolean;
}

const FAQSection = ({ faq_section, isFirstQuestionOpen }: Props) => {
  return (
    <div
      style={{
        backgroundColor: faq_section.bg_color,
      }}
      className="flex flex-col p-16 px-4 pb-24"
    >
      <div className="mx-auto w-full max-w-5xl">
        {/** Headings */}
        <div className="mb-2 flex w-full flex-col items-center space-y-2">
          {faq_section.overline && (
            <Typography
              as="span"
              size={faq_section.overline_font_size}
              weight="bold"
              fontFamily={faq_section.overline_font_family}
              color={faq_section.overline_color}
              className={cx({
                'w-full': true,
                'text-center': faq_section.text_align === 'center',
                'text-left': faq_section.text_align === 'left',
                'text-right': faq_section.text_align === 'right',
              })}
            >
              <MarkDownRender>{faq_section.overline}</MarkDownRender>
            </Typography>
          )}
          <Typography
            as="h1"
            size={faq_section.headline_font_size}
            weight="bold"
            fontFamily={faq_section.headline_font_family}
            color={faq_section.headline_color}
            className={cx({
              'w-full': true,
              'text-center': faq_section.text_align === 'center',
              'text-left': faq_section.text_align === 'left',
              'text-right': faq_section.text_align === 'right',
            })}
          >
            <MarkDownRender>{faq_section.headline}</MarkDownRender>
          </Typography>
        </div>

        {/** FAQS */}
        <FAQs faqSection={faq_section} isFirstQuestionOpen={isFirstQuestionOpen} />
      </div>
    </div>
  );
};

export default FAQSection;
